<app-topbar></app-topbar>
<div class="container mr-top-56 respmrt-0">
			
    <!-- Payment Detail -->
        <div class="common row mr-top-20 mr-bttm-68">
            <div class="col-md-12 prfl_data_side">
                <form [formGroup]="CompanyForm" (ngSubmit)="Submit()" enctype="multipart/form-data">
                <div class="prflhdng mr-bttm-45">
                    <h6 class="pyhdng pyhdngresp mr-bttm-5">Add Company & Store</h6>
                    <p class="text-left boxpara">You can add multiple stores with each company</p>
                </div>
                <div class="common addcompanymain marginbottomsamesec">
                    <div class="caddtitle">
                        <p>Add Company</p>
                    </div>
                    <div class="addcompanyformarea">
                       
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="company_name" type="text" class="form-control"  placeholder="Company Name">
                                        <div *ngIf="submitted && f.company_name.invalid">
                                            <span class="inputValidation" *ngIf="f.company_name.errors.required">Company Name is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="owner_name" type="text" class="form-control" placeholder="Owner Name">
                                        <div *ngIf="submitted && f.owner_name.invalid">
                                            <span class="inputValidation" *ngIf="f.owner_name.errors.required">Owner Name is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="contact_number" type="text" class="form-control"  placeholder="Contact No." maxlength="15" minlength="10" mask='(000) 000-0000'>
                                        <div *ngIf="submitted && f.contact_number.invalid">
                                            <span class="inputValidation" *ngIf="f.contact_number.errors.required">Contact Number is required.</span>
                                            <span class="inputValidation" *ngIf="f.contact_number.errors.minlength">Contact Number is invalid.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="email_Address" type="email" class="form-control"  placeholder="Email Address">
                                        <div *ngIf="submitted && f.email_Address.invalid">
                                            <span class="inputValidation" *ngIf="f.email_Address.errors.required">Email Address is required.</span>
                                            <span class="inputValidation" *ngIf="f.email_Address.errors.email">Email Address is invalid.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="address_line1" type="text" class="form-control"  placeholder="Address Line 1">
                                        <div *ngIf="submitted && f.address_line1.invalid">
                                            <span class="inputValidation" *ngIf="f.address_line1.errors.required">Address Line 1 is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input type="text" class="form-control" placeholder="Address Line 2">
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <!-- <input formControlName="country" type="text" class="form-control" name="country" placeholder="Country"> -->
                                        <select class="pymntmthds form-control" id="country" autocomplete="off"
                                            (change)="changeState($event.target.value)"
                                            formControlName="country">
                                            <option value="">Select Country</option>
                                            <option *ngFor="let country of countries" [value]="country.id">
                                            {{country.name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.country.invalid">
                                            <span class="inputValidation" *ngIf="f.country.errors.required">Country is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <div *ngIf="stateLoading else selectState">
                                            <img src="assets/images/loading.gif" class="loading_gif"/>
                                        </div>   
                                        <ng-template #selectState>
                                            <select class="pymntmthds form-control" id="state" autocomplete="off"
                                                formControlName="State">
                                                <option value="">Select State</option>
                                                <option *ngFor="let state of states" [value]="state.id">
                                                {{state.name}}
                                                </option>
                                            </select>
                                        </ng-template>
                                        <div *ngIf="submitted && f.State.invalid">
                                            <span class="inputValidation" *ngIf="f.State.errors.required">State is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <input formControlName="city" type="text" class="form-control"  placeholder="City">
                                        <div *ngIf="submitted && f.city.invalid">
                                            <span class="inputValidation" *ngIf="f.city.errors.required">City is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <input formControlName="zip" type="text" class="form-control" placeholder="Zip">
                                        <div *ngIf="submitted && f.zip.invalid">
                                            <span class="inputValidation" *ngIf="f.zip.errors.required">Zip is required.</span>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>

                    </div>
                    
                </div>
                <div class="common addcompanymain" formArrayName="Stores" *ngFor="let group of StoreArray.controls; let i = index">
                    <div class="caddtitle">
                        <p>Manage Stores</p>
                    </div>
                    <div class="addcompanyformarea" [formGroupName]="i">
                        <!-- <form method="post"> -->
                            <div class="formrow">
                                <span class="upldimg">
                                    <p class="imgfrme">
                                       <span>
                                       <img [src]="group.controls.Storeimage.value"
                                       [hidden]="!group.controls.Storeimage.value" />
                                       </span>
                                    </p>
                                 </span>
                                 <img src="assets/images/uploadlogo.png"/>
                                  <label for="files" class="uploadlogoclass">Upload Logo</label>
                                  <input (change)="selectImage($event,i)"  accept="image/x-png,image/gif,image/jpeg" id="files" style="visibility:hidden;" type="file">
                            
                            </div>
                            <div class="formrow">
                                <p class="brandtext">Please, select the color of your  store branding,<br/> it will be for custom some emails.</p>
                            </div>
                            <div class="formrow formrowcolorsec">
                                 <div class="text-left mbottomscolor cprimaryseccolor">
                                    
                                    <p class="brandtext">Primary Color</p>
                                    <div class="primary_div ClrPckrDiv">
                                        <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span><input  class="cstm_color_picker" id="cstm_color_picker{{i}}"  
                                         [cpOKButton]="true"
                                        [cpSaveClickOutside]="false"
                                        [cpOKButtonClass]= "'btn btn-primary btn-xs'"
                                        [(colorPicker)]="'color'+colorBlank" autocomplete="off" readonly
                                        (colorPickerSelect)="handleChangeComplete($event,i)"/>
                                    </div>
                                   <!--  <span *ngIf="StoreArray.controls[i].get('primary_color').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                        class="inputValidation">
                                            Primary Color required.
                                        </span> -->

                                    <!-- <span id="color-picker-primary" class="color-picker-2">
                                        <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span> <img src="assets/images/color2.png"/> 
                                     </span> -->
                                  </div>
                                <!-- <div class="text-left mbottomscolor cprimaryseccolor">
                                    <p class="brandtext">Secondary Color</p>
                                    <span id="color-picker-secondary" class="color-picker-2">
                                        <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span> <img src="assets/images/color2.png"/> 
                                     </span>
                                  </div> -->
                                
                            </div>
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="store_name" type="text" class="form-control"  placeholder="Store Name">
                                        <span *ngIf="StoreArray.controls[i].get('store_name').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                        class="inputValidation">
                                                Store name required.
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="owner_name" type="text" class="form-control" placeholder="Owner Name">
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('owner_name').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Owner name required.
                                                </span>
                                                
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input type="text" class="form-control" placeholder="Contact No." formControlName="contact_number" maxlength="15" minlength="10" mask='(000) 000-0000'>
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('contact_number').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Contact number is required.
                                                </span>
                                                <span
                                                   *ngIf="StoreArray.controls[i].get('contact_number').errors?.minlength"
                                                   class="inputValidation">
                                                Contact number is invalid.
                                                </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input type="email" class="form-control" placeholder="Email Address" formControlName="email_Address">
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('email_Address').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Email Address required.
                                                </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input formControlName="address_line1" type="text" class="form-control" placeholder="Address Line 1">
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('address_line1').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Address Line 1 required.
                                                </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group ">
                                        <input type="text" class="form-control" placeholder="Address Line 2">
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <select (change)="changeStateStore($event.target.value, i)" formControlName="country" class="form-control" >
                                        <option value="">Select Country</option>
                                            <option *ngFor="let country of countries" [value]="country.id">
                                            {{country.name}}</option>
                                        </select>
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('country').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Country required.
                                                </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <div *ngIf="stateLoadingStore[i] else selectState">
                                            <img src="assets/images/loading.gif" class="loading_gif"/>
                                        </div>   
                                        <ng-template #selectState>
                                            <select class="pymntmthds form-control" id="state" autocomplete="off"
                                                formControlName ="State">
                                                <option value="">Select State</option>
                                                <option *ngFor="let state_store of States[i]" [value]="state_store.id">
                                                {{state_store.name}}
                                                </option>
                                            </select>
                                        </ng-template>
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('State').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                State required.
                                                </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <input formControlName="city" type="text" class="form-control" placeholder="City">
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('city').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                City name required.
                                                </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formrow row">
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <input formControlName="zip" type="text" class="form-control" placeholder="Zip">
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('zip').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                Zip Code is required.
                                                </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <select formControlName="timezone" class="form-control">
                                            <option value="">Select Timezone</option>
                                            <option *ngFor="let timezone of timezones" [value]="timezone.name">
                                                {{timezone.gmt}}</option>
                                        </select>
                                        <span
                                                   *ngIf="StoreArray.controls[i].get('timezone').errors?.required && isValidFormSubmitted != null && !isValidFormSubmitted"
                                                   class="inputValidation">
                                                   Timezone required.
                                                </span>
                                        
                                    </div>
                                </div>
                                
                            </div>
                        <!-- </form> -->
                    </div>
                    <div *ngIf = "i >= 1">
                        <button (click) ="removeRow(i)" class=" float-right btn btn-danger cstm_rm_btn">Remove</button>
                        </div>
                </div>
                
                <div class="cliakaddnewstore">
                </div>
                <div class="common mr-top-20 updateaddstorebtnreverse">
                    <div class="respflexupdate">
                    <button class="updtbttnaddstore" >Update</button>
                    <!-- <button class="cancelbtnaddstore">Cancel</button> -->
                    </div>
                    <div class="respflexupdateanoth">
                    <a href="javascript:void(0)" class="addanothstore_new" (click)="addNewRow()"><img src="assets/images/addanothersrore.png"/>Add Another Store</a></div>
                </div>
            </form>
            </div>

        </div>
    

</div>


<!-- Change Image Modal -->
<div class="modal" id="changepictureModal">
<div class="modal-dialog ">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changeimagebody">
    <div class="common ">
        <div class="changeimagediv text-center mr-top-60">
            
            <form action="">
              <img src="assets/images/change_img.png" class="changeimg">
              <input type="file" class="upldimgfile" id="img" name="img" accept="image/*">
                      <div class="common upldpctrtxt text-center">
                          <p class="text-center mr-bttm-35"><a href="" class="rmbrme clrblue">Upload picture</a> </p>
                        <button class="savebttn">Save</button>
                        <button class="cancelbttn">Cancel</button>
                      </div>
            </form>

        </div>
    </div>

</div>



</div>
</div>
</div>

<!-- Change Image Modal -->

<!-- Change Email Modal -->
<div class="modal" id="changeemailModal">
<div class="modal-dialog chngnmbrpopup">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changenumberbody">
    <div class="common billingform changenumber">
        <form>
            <h6 class="sucssheading clrgry text-left">Change your email</h6>
            <div class="form-group">
                <input type="text" name="" class="form-control" placeholder="Enter Email">
            </div>
            <div class="common changenumberbttn text-left">
                <button class="savebttn">Save</button>
                <button class="cancelbttn">Cancel</button>
              </div>
        </form>
    </div>

</div>



</div>
</div>
</div>
<!-- Change Email Modal -->

<!-- Phone Number Modal -->
<div class="modal" id="changephoneModal">
<div class="modal-dialog chngnmbrpopup">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changenumberbody">
    <div class="common billingform changenumber">
        <form>
            <h6 class="sucssheading clrgry text-left">Change your phone</h6>
            <div class="form-group">
                <input type="text" name="" class="form-control" placeholder="(123) 456-7890">
            </div>
            <div class="common changenumberbttn text-left">
                <button class="savebttn">Save</button>
                <button class="cancelbttn">Cancel</button>
              </div>
        </form>
    </div>

</div>



</div>
</div>
</div>
<!-- Phone Number Modal -->

<!-- Address Modal -->
<div class="modal" id="changeaddressModal">
<div class="modal-dialog chngnmbrpopup">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changenumberbody">
    <div class="common billingform changenumber">
        <form>
            <h6 class="sucssheading clrgry text-left">Change your address</h6>
            <div class="form-group">
                    <input type="text" class="form-control" placeholder="Address">
            </div>        			
            <div class="form-group row">
              <div class="col-md-6 col-sm-6 col-xs-6">
                    <input type="text" class="form-control" placeholder="City">
               </div>
               <div class="col-md-6 col-sm-6 col-xs-6">
                    <input type="text" class="form-control" placeholder="State">
               </div>
            </div>
            <div class="form-group row mr-bttm-0">
              <div class="col-md-6 col-sm-6 col-xs-6">
                    <input type="text" class="form-control" placeholder="Zip Code">
               </div>
            </div>
            <div class="common changenumberbttn text-left">
                <button class="savebttn">Save</button>
                <button class="cancelbttn">Cancel</button>
              </div>
        </form>

    </div>

</div>



</div>
</div>
</div>
<!-- Address Modal -->

<!-- Password Modal -->
<div class="modal" id="changepasswordModal">
<div class="modal-dialog chngnmbrpopup">
<div class="modal-content">    


<!-- Modal body -->
<div class="modal-body changenumberbody">
    <div class="common billingform changenumber">
        <form>
            <h6 class="sucssheading clrgry text-left">Change your password</h6>
            <div class="form-group">
                <input type="text" name="" class="form-control" placeholder="Current Password">
            </div>
            <div class="form-group">
                <input type="text" name="" class="form-control" placeholder="New Password">
            </div>
            <div class="form-group mr-bttm-0">
                <input type="text" name="" class="form-control" placeholder="Confirm Password">
            </div>
            <div class="common changenumberbttn text-left">
                <button class="savebttn">Save</button>
                <button class="cancelbttn">Cancel</button>
              </div>
        </form>
    </div>

</div>



</div>
</div>
</div>
<!-- Password Modal -->

<!-- SCRIPTS -->

<script>





</script>
<!-- SCRIPTS -->